import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button, Divider, Typography } from "@mui/material";
import { addFaq, addFaqEntry, getFaq, removeFaq, removeFaqEntry } from "../../api/faq.api";
import { useAuth } from "../../context/auth.context";
import CreateFaqCategoryModal from "../../components/modals/createFaqCategory.modal";
import CreateFaqEntryModal from "../../components/modals/createFaqEntry.modal";
import DeleteIcon from "@mui/icons-material/Delete";

const FaqPage = () => {
  const [faq, setFaq] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEntryModal, setOpenEntryModal] = useState(false);

  const auth = useAuth();

  useEffect(() => {
    getFaq()
      .then((response) => setFaq(response.data))
      .catch((e) => console.log(e));
  }, [refresh]);

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const handleCloseCreateModal = () => {
    setOpenCreateModal(false);
  };

  const handleCreateSubmit = (formData) => {
    addFaq(formData)
      .then(() => setRefresh((prev) => !prev))
      .catch((e) => console.log(e));
  };

  const handleOpenEntryModal = () => {
    setOpenEntryModal(true);
  };

  const handleCloseEntryModal = () => {
    setOpenEntryModal(false);
  };

  const handleEntrySubmit = (formData) => {
    addFaqEntry(formData.categoryId, formData)
      .then(() => setRefresh((prev) => !prev))
      .catch((e) => console.log(e));
  };

  const handleRemoveCategory = (categoryId) => {
    removeFaq(categoryId)
    .then(() => setRefresh((prev) => !prev))
    .catch((e) => console.log(e));
  };

  const handleRemoveEntry = (categoryId, entryId) => {
    removeFaqEntry(categoryId, entryId)
    .then(() => setRefresh((prev) => !prev))
    .catch((e) => console.log(e));
  };

  return (
    <div className="dashboard-container">
      <Typography variant="h3" gutterBottom>
        FAQ
      </Typography>

      {auth && auth.user && auth.user.role === "Admin" && (
        <Box>
          <Button
            variant="contained"
            onClick={handleOpenCreateModal}
            sx={{ mt: 1 }}
          >
            Create Category
          </Button>

          <Button
            variant="contained"
            onClick={handleOpenEntryModal}
            sx={{ mt: 1, ml: 1 }}
          >
            Create Entry
          </Button>
        </Box>
      )}

      <Divider sx={{ mt: 1, mb: 1 }} />

      {faq &&
        faq.length > 0 &&
        faq.map((faqCategory) => (
          <div key={faqCategory.id}>
            <Box display="flex" justifyContent="left" alignItems="center">
              <Typography variant="h4" gutterBottom sx={{ mt: 1 }}>
                {faqCategory.name}
              </Typography>
              {auth &&
                auth.user &&
                auth.user.role === "Admin" &&
                faqCategory.faqEntries &&
                faqCategory.faqEntries.length == 0 && (
                  <Button
                    sx={{ ml: 1 }}
                    variant="outlined"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleRemoveCategory(faqCategory.id)}
                  >
                    Delete
                  </Button>
                )}
            </Box>
            {faqCategory.faqEntries &&
              faqCategory.faqEntries.length > 0 &&
              faqCategory.faqEntries.map((entry) => (
                <Accordion key={entry.id}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box>{entry.title}</Box>
                      <Box sx={{ ml: 'auto' }}>
                        {auth && auth.user && auth.user.role === "Admin" && (
                          <Button
                            sx={{ ml: 1 }}
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={() => handleRemoveEntry(faqCategory.id, entry.id)}
                          >
                            Delete
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>{entry.description}</AccordionDetails>
                </Accordion>
              ))}
          </div>
        ))}

      <CreateFaqCategoryModal
        aria-modal
        open={openCreateModal}
        handleClose={handleCloseCreateModal}
        handleSubmit={handleCreateSubmit}
      />

      <CreateFaqEntryModal
        aria-modal
        open={openEntryModal}
        handleClose={handleCloseEntryModal}
        handleSubmit={handleEntrySubmit}
        categories={faq}
      />
    </div>
  );
};

export default FaqPage;
